import t from "./_arrayMap.js";
import o from "./_baseIteratee.js";
import p from "./_baseMap.js";
import e from "./isArray.js";
function n(r, a) {
  var m = e(r) ? t : p;
  return m(r, o(a));
}
export {
  n as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/lodash-es@4.17.21/~/lodash-es/map.js
// module id = 1524
// module chunks = 41